import React from "react";
export const useMutationObserver = (ref, callback) => {
  React.useEffect(() => {
    const options = {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true
    };
    if (ref.current) {
      const observer = new MutationObserver(callback);
      observer.observe(ref.current, options);
      return () => observer.disconnect();
    }
  }, [callback]);
};